(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomMaterialTypeAttributeDeleteController',CustomMaterialTypeAttributeDeleteController);

    CustomMaterialTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomMaterialTypeAttribute'];

    function CustomMaterialTypeAttributeDeleteController($uibModalInstance, entity, CustomMaterialTypeAttribute) {
        var vm = this;

        vm.customMaterialTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomMaterialTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
